import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import VocabBDView from '../../VocabBDView';
import { onResponseSelect } from '../../../vocabActions';
import { fetchVocabBDContent } from '../../vocabBDActions';
import { stopAudio, narrateReset } from '../../../../common/audio/audioActions';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';
import { narrateStimulus, resetSelectedIndex } from '../../../../common/questions/questionsActions';
import { narratePracticeScreen, onNextPracticeButtonClick } from './VocabBDPracticeActions';
import { unmountScreen } from '../../../../common/screen/screenActions';
import { VOCAB_AUDIO_INSTRUCTIONS } from '../../../vocabConstants';
import { PRACTICE } from '../../../../constants/assessmentItemType';
import { getAvatarPosition } from '../../../../common/alex/AlexUtils';

const mapStateToProps = state => ({
    isDataFetched: selectors.getIsVocabBDDataFetched(state),
    stimulus: selectors.getVocabBDStimulusInfo(state, PRACTICE),
    possibleResponses: selectors.getVocabBDPossibleResponses(state, PRACTICE),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
    isStimulusPlaying: selectors.getIsStimulusPlaying(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    selectedResponse: selectors.getSelectedIndex(state),
});

const mapDispatchToProps = dispatch => ({
    fetchContent: () => {
        dispatch(fetchVocabBDContent());
    },
    narrateScreen: stimulusAudio => dispatch(narratePracticeScreen(stimulusAudio)),
    playStimulus: stimulusAudio => dispatch(narrateStimulus(stimulusAudio)),
    selectResponse: response => dispatch(onResponseSelect(response)),
    onNext: () => dispatch(onNextPracticeButtonClick()),
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(resetSelectedIndex());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = state => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.MIDDLE_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions:
            VOCAB_AUDIO_INSTRUCTIONS[selectors.getCurrentLanguage(state)]
                .vocabBDPracticeInstructionStart,
    };
};

const VocabBDPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(VocabBDView);

export default VocabBDPracticeContainer;
